import React from 'react';

export const convertForRealFormatted = (number = 0, minimum = 0) => {
  return (
    <div className="real-formatted">
      <span></span>
      <span>
        {new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: minimum,
          maximumFractionDigits: 2,
        }).format(number)}
      </span>
    </div>
  );
};


export const convertForRealFormattedPrecise = (number = 0, minimum = 0, maximum = 4) => {
  return (
    <div className="real-formatted">
      <span></span>
      <span>
        {new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: minimum,
          maximumFractionDigits: maximum, // Permite até 4 casas decimais
        }).format(number)}
      </span>
    </div>
  );
};